// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleTwoToneSvg from "@fishx/icons-svg/es/asn/LeftCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleTwoToneSvg
  }));
};

LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
export default React.forwardRef(LeftCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftCircleTwoTone.js
// module id = 3026
// module chunks = 0